var React = require('react');

function Broom (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M636.53 31A16 16 0 0 1 634 53.47l-232.5 177.8-39.72-50L594.26 3.47A15.94 15.94 0 0 1 616.67 6l19.86 25z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M93.17 257.71c-21.88 17.43-40.17 55.81-54.6 97.47L99 333.09a6 6 0 0 1 6.65 9.5L11 454.76c-7.2 32.29-11 55.43-11 55.43s206.66 13.66 266.63-34.12S343.2 326 343.2 326l-86.73-109.23S153.14 210 93.17 257.71zm342.42 16.48L327.64 138.3a11 11 0 0 0-18.59 2.21l-25.33 54.55 86.73 109.18 58.8-12.45a11 11 0 0 0 6.34-17.6z","className":"fa-primary","key":2})]);
}

Broom.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Broom;

Broom.default = Broom;
